import { useTranslation } from "react-i18next";

import { DaysFilterDropdown } from "pstat-anywhere/components/document_reports/expiring/components/DaysFilterDropdown";

export const ExpirationFilterDropdown = props => {
  const { t } = useTranslation();
  const filterName = t(
    "documentReports.expiring.expirationFilterDropdown.title"
  );
  const expandedFilterName = t(
    "documentReports.expiring.expirationFilterDropdown.expandedTitle"
  );
  const inputLabel = t(
    "documentReports.expiring.expirationFilterDropdown.inputLabel"
  );
  const inputName = "daysUntilExpiration";
  const inputId = "days_until_expiration_field";
  const daysFilterProps = {
    ...props,
    filterName,
    expandedFilterName,
    inputLabel,
    inputName,
    inputId
  };
  return <DaysFilterDropdown {...daysFilterProps} />;
};
